const wishlistConfig = window?.["wishlistConfig"];
const cartConfig = window?.["cartConfig"];
export const wishlistsApi = wishlistConfig?.wishlistsApi ?? "";
export const baseCartApiUrl = cartConfig?.baseCartApiURL ?? "";
export const userId = cartConfig?.userId ?? "";
export const baseSiteId = cartConfig?.baseSiteId ?? "";
export const addToCartButtonEnabled =
  cartConfig?.addToCartButtonEnabled ?? false;
